import { useState } from 'react'
import { Card, Button, Typography } from '@arco-design/web-react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SystemTokenModal from './modals/SystemTokenModal'
import AccessTokenManageModal from './modals/AccessTokenManageModal'
import type { SecureRunner } from '@/hooks/useSecureVerification'

interface SystemAccessTokenCardProps {
  runSecure: SecureRunner
}

export default function SystemAccessTokenCard({ runSecure }: SystemAccessTokenCardProps) {
  const { t } = useTranslation()
  const [token, setToken] = useState('')
  const [modalOpen, setModalOpen] = useState(false)
  const [manageOpen, setManageOpen] = useState(false)

  return (
    <>
      <Card
        className="tt-card !rounded-2xl !border-[var(--console-border)]"
        title={t('personal.token.title')}
      >
        <Typography.Paragraph className="text-sm text-[var(--console-text-muted)] !mb-3">
          {t('personal.token.desc')}
        </Typography.Paragraph>
        <Link
          to="/console/api-keys"
          className="text-sm text-[var(--brand-primary)] hover:underline"
        >
          {t('personal.token.apiKeysLink')} →
        </Link>
        <div className="mt-4">
          <Button type="outline" onClick={() => setManageOpen(true)}>
            {t('personal.token.reset')}
          </Button>
        </div>
      </Card>

      <SystemTokenModal visible={modalOpen} token={token} onClose={() => setModalOpen(false)} />

      <AccessTokenManageModal
        visible={manageOpen}
        runSecure={runSecure}
        onCancel={() => setManageOpen(false)}
        onCreated={(value) => {
          setToken(value)
          setManageOpen(false)
          setModalOpen(true)
        }}
      />
    </>
  )
}
